<template>
    <div class="custom-dropdown" v-click-outside="handleOutsideClick">
      <div class="dropdown-header" @click="toggleDropdown">
        {{ selected || placeholder }}
      </div>
      <div v-if="isOpen" class="dropdown-options">
        <div
          v-for="(item, index) in data"
          :key="index"
          class="dropdown-option"
          @click="selectItem(item)"
        >
          {{ item }}
        </div>
      </div>
    </div>
  </template>
<script>
let openDropdownInstance = null; 
export default {
  name: "LateTimeDropdown",
  props: {
    data: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: "--"
    },
    selected: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleDropdown() {
      if (openDropdownInstance && openDropdownInstance !== this) {
        openDropdownInstance.closeDropdown();
      }

      this.isOpen = !this.isOpen;
      openDropdownInstance = this.isOpen ? this : null;
    },
    selectItem(item) {
      this.$emit("change", item);
      this.closeDropdown();
    },
    closeDropdown() {
      this.isOpen = false;
      if (openDropdownInstance === this) {
        openDropdownInstance = null;
      }
    },
    handleOutsideClick() {
      this.closeDropdown();
    }
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.__ClickOutsideHandler__ = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener("click", el.__ClickOutsideHandler__);
      },
      unbind(el) {
        document.removeEventListener("click", el.__ClickOutsideHandler__);
        el.__ClickOutsideHandler__ = null;
      }
    }
  }
};
</script>
  
  <style scoped>
  .custom-dropdown {
    position: relative;
    display: inline-block;
    /* margin-right: 10px; */
  }

  .dropdown-header {
    padding: 8px 12px;
    border: 1px solid #ccc;
    background-color: white;
    border-radius: 4px;
    cursor: pointer;
    /* min-width: 15px; */
    text-align: center;
  }

  .dropdown-options {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 9999;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 100%;
    max-height: 150px;
    overflow-y: auto;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .dropdown-option {
    /* padding: 8px; */
    cursor: pointer;
  }

  .dropdown-option:hover {
    background-color: #f0f0f0;
  }
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/LateTimeDropdown.vue